import ReservationItem from './reservation-item';

export default class ReservationData {
    public UserId: string = "";
    public PersonId?: number | null;

    public Items: Array<ReservationItem> = new Array<ReservationItem>();
}